import { useMutation, useQueryClient } from "@tanstack/vue-query";
import BucketOption from "@/services/bucket/bucket-option";

export function useDeleteBucketOption() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (bucketOptionId: string) => {
      const result = await BucketOption.deleteBucketOption(bucketOptionId);

      if (result.data.status) {
        return result.data.data;
      }

      throw new Error(result.data.msg || "Failed to delete bucket option");
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bucketOptions"], refetchType: "all" });
      queryClient.invalidateQueries({ queryKey: ["buckets"], refetchType: "all" });
      queryClient.invalidateQueries({ queryKey: ["bucketStats"], refetchType: "all" });
      queryClient.invalidateQueries({ queryKey: ["bucketCounts"], refetchType: "all" });
      queryClient.invalidateQueries({ queryKey: ["dashboardStats"], refetchType: "all" });
    },
  });
}

export function useCreateBucketOption() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: any) => {
      const result = await BucketOption.registerBucketOption(payload);

      if (result.data.status) {
        return result.data.data;
      }

      throw new Error(result.data.msg || "Failed to create bucket option");
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bucketOptions"], refetchType: "all" });
      queryClient.invalidateQueries({ queryKey: ["buckets"], refetchType: "all" });
      queryClient.invalidateQueries({ queryKey: ["bucketStats"], refetchType: "all" });
      queryClient.invalidateQueries({ queryKey: ["bucketCounts"], refetchType: "all" });
      queryClient.invalidateQueries({ queryKey: ["dashboardStats"], refetchType: "all" });
    },
  });
}

export function useUpdateBucketOption() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: any) => {
      const result = await BucketOption.editBucketOption(payload);

      if (result.data.status) {
        return result.data.data;
      }

      throw new Error(result.data.msg || "Failed to update bucket option");
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bucketOptions"], refetchType: "all" });
      queryClient.invalidateQueries({ queryKey: ["buckets"], refetchType: "all" });
      queryClient.invalidateQueries({ queryKey: ["bucketStats"], refetchType: "all" });
      queryClient.invalidateQueries({ queryKey: ["bucketCounts"], refetchType: "all" });
      queryClient.invalidateQueries({ queryKey: ["dashboardStats"], refetchType: "all" });
    },
  });
}
